import Rate from 'rc-rate';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Card = styled.div`
  padding: 14px 24px;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  border-radius: 4px;
  display: flex;
  width: 100%;
  margin-bottom: 12px;
  ${mq(1200)} {
    padding: 14px;
  }
`;

export const UserImage = styled.div`
  max-width: 50px;
  min-width: 50px;
  max-height: 50px;
  min-height: 50px;
  margin-right: 20px;
  border-radius: 50px;
  border: 1px solid ${({ theme }) => theme.colors.lightPurple};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;
export const UserName = styled.div`
  font-size: 1.6rem;
`;
export const P = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black};
  min-height: ${14 * 1.4 * 2}px;
  max-height: ${14 * 1.4 * 5}px;
`;

export const StyledRate = styled(Rate)`
  &.rc-rate {
    height: 16px;
    font-size: ${({ theme }) => theme.fontsizes.body14};
    transform: translateY(-3px) /* rtl: none */;
    .rc-rate-star {
      margin-right: 2px;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
`;

export const Date = styled.div`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.auth.lightPurple};
  /* max-width: 72px; */
  /* overflow: hidden; */
  white-space: nowrap;
`;
